<div class="heading">
    <p>Edit User</p>
</div>
<div class="container mb-20">
    <h4 class="m-0 mb-4" style="color: #091734;">{{data?.username}}</h4>
    <p class="m-0" style="color: #091734; font-weight: 400; font-size: 14px;">{{data?.email}}</p>
</div>
<div class="container mb-20">
    <label for="role" style="color: #5E5E72; font-size: 14px; font-weight: 700; display: inline-block;"
        class="mb-4">Role <span class="required">*</span></label>
    <div class="select-container">
        <select id="role" class="dropdown w-100" [(ngModel)]="selectedRole" (change)="roleItemChange($event)" required #roleRef="ngModel">
            <option *ngFor="let role of rolesList" [value]="role.role_name" style="color: #0F1A2E;">{{role?.role_name?.charAt(0)?.toUpperCase() + role?.role_name?.slice(1)}}</option>
        </select>
        <div *ngIf="roleRef.invalid && roleRef.touched" style="color: red;">Please Select a role</div>
    </div>
</div>
<div class="container mb-20" *ngIf="selectedRole === 'curator'">
    <label for="category" style="color: #5E5E72; font-size: 14px; font-weight: 700; display: inline-block;"
        class="mb-4">Choose Curator category <span class="required">*</span> </label>
    <div class="select-container" style="width: 93%;">
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="categoryDropdownList"
            [(ngModel)]="selectedCategoryItems" (ngModelChange)="onCategoryItemSelect($event)">
        </ng-multiselect-dropdown>
        <div *ngIf="!selectedCategoryItems.length && isCatvalid" style="color: red;">Please Select category</div>
    </div>
</div>
<div class="btn-container">
    <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'"
        [iconSrc]="'/assets/admin-images/cancel_icon.svg'" class="mr-12" (click)="close()"></app-button>
    <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Update'"
        [iconSrc]="'/assets/admin-images/person_check.svg'" (click)="updateUser()"></app-button>
</div>